export default __webpack_public_path__ + "static/media/loge-transparent.9f803ea4.png";